import React from "react";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles({
  progress: {
    marginBottom: 0,
    zIndex: 999,
    // height: 2,
  },
});

export default function ({ className, ...props }) {
  const classes = useStyles();

  return (
    <LinearProgress
      className={clsx([classes.progress, className])}
      {...props}
    />
  );
}
